import RootStore from './store';
import BreadcrumbsStore from './breadcrumbsStore';

const rootStoreInstance = new RootStore();
const Breadcrumbs = new BreadcrumbsStore();

export { RootStore, rootStoreInstance, Breadcrumbs, BreadcrumbsStore };
